import React, { useEffect, useState } from 'react';
import { useModal } from '../../context/ModalContext';
import CdnMobContents from '../modalcontents/CdnMobContents';
import CdnDownloadContents from '../modalcontents/CdnDownloadContents';
import CdnStreamingContents from '../modalcontents/CdnStreamingContents';
import CdnCachingContents from '../modalcontents/CdnCachingContents';
import NaverModalContents from '../modalcontents/NaverModalContents';
import AwsModalContents from '../modalcontents/AwsModalContents';
import NhnModalContents from '../modalcontents/NhnModalContents';

const Modal = ({ isOpen, onClose, children }) => {
  const [visible, setVisible] = useState(false);
  const { modalContentKey, modalSubContentKey } = useModal();
  useEffect(() => {
    let timeout;
    if (isOpen) {
      setVisible(true);
    } else {
      // 페이드 아웃 효과를 위해 잠시 delay
      timeout = setTimeout(() => setVisible(false), 300);
    }
    return () => clearTimeout(timeout);
  }, [isOpen]);
  // useEffect(() => {
  //   if (isOpen) {
  //     // 현재 스크롤 위치 저장
  //     const scrollY = window.scrollY;
  //     document.body.style.position = 'fixed';
  //     document.body.style.top = `-${scrollY}px`;
  //     document.body.style.overflow = 'hidden';
  //     document.body.style.width = '100%';
  //
  //     return () => {
  //       // 복구
  //       document.body.style.position = '';
  //       document.body.style.top = '';
  //       document.body.style.overflow = '';
  //       document.body.style.width = '';
  //
  //       window.scrollTo(0, scrollY); // 스크롤 위치 복구
  //     };
  //   }
  // }, [isOpen]);
  if (!isOpen && !visible) return null;
  const renderContentWithTitle = () => {
    switch (modalContentKey) {
      case 'caching':
        return {
          title: '캐싱 서비스',
          content: <CdnCachingContents />,
        };
      case 'download':
        return {
          title: '다운로드 서비스',
          content: <CdnDownloadContents />,
        };
      case 'streaming':
        return {
          title: '스트리밍 서비스',
          content: <CdnStreamingContents />,
        };
      case 'mobile':
        return {
          title: '모바일 CDN',
          content: <CdnMobContents />,
        };
      case 'naverModal':
        return {
          title: 'Solutions',
          content: (
            <NaverModalContents solutionActiveIndex={modalSubContentKey} />
          ),
        };
      case 'awsModal':
        return {
          title: 'Solutions',
          content: (
            <AwsModalContents solutionActiveIndex={modalSubContentKey} />
          ),
        };
      case 'nhnModal':
        return {
          title: 'Solutions',
          content: (
            <NhnModalContents solutionActiveIndex={modalSubContentKey} />
          ),
        };
      default:
        return {
          title: '알 수 없음',
          content: <div style={{ padding: '20px' }}>컨텐츠가 없습니다.</div>,
        };
    }
  };

  const { title, content } = renderContentWithTitle();
  // const renderContent = () => {
  //   switch (modalContentKey) {
  //     case 'caching':
  //       return <CdnCachingContents />;
  //     case 'download':
  //       return <CdnDownloadContents />;
  //     case 'streaming':
  //       return <CdnStreamingContents />;
  //     case 'mobile':
  //       return <CdnMobContents />;
  //     default:
  //       return <div style={{ padding: '20px' }}>컨텐츠가 없습니다.</div>;
  //   }
  // };
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 999999,
        opacity: isOpen ? 1 : 0,
        transition: 'opacity 0.3s ease',
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '8px',
          height: '80vh',
          width: 'calc(100% - 40px)',
          marginLeft: '-20px',
          marginRight: '-20px',
          overflow: 'hidden',
          position: 'relative',
          transform: isOpen ? 'translateY(0)' : 'translateY(20px)',
          transition: 'transform 0.3s ease',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{ height: '100%' }}
          className={`flex-col flex-full  ${modalContentKey !== 'gap-16'}`}
        >
          <div
            style={{
              background: '#fff',
              width: '100%',
              top: '0',
            }}
            className="flex-row justify-between align-center py-16 px-16"
          >
            <div className={`flex-row gap-8 align-center `}>
              <div
                style={{ width: 4, height: 16, background: '#1581FC' }}
              ></div>
              <span
                style={{
                  color: '#232323',
                  fontFamily: '"Pretendard Variable"',
                  fontSize: '20px',
                  fontStyle: 'normal',
                  fontWeight: 600,
                  lineHeight: '120%',
                  letterSpacing: '-0.6px',
                  leadingTrim: 'both',
                  textEdge: 'cap',
                }}
              >
                {title}
              </span>
            </div>
            <button
              onClick={onClose}
              style={{
                // position: 'absolute',
                top: '24px',
                right: '24px',
                display: 'block',
                background: 'none',
                border: 'none',
                fontSize: '32px',
                cursor: 'pointer',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clip-path="url(#clip0_2091_393)">
                  <path
                    d="M18 6L6 18"
                    stroke="#232323"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 6L18 18"
                    stroke="#232323"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2091_393">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
          <div
            style={{
              flex: 1,
              overflowY: 'auto',
              // padding: '16px',
            }}
          >
            {content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
